export default __webpack_public_path__ + "static/media/logo.204ff2d5.svg";